import React from 'react';
import { useNavigate } from 'react-router-dom';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import OverviewCardShell, { OverviewTextAction } from './OverviewCardShell';
import styles from './StandardOverview.module.css';

const VDRCard = ({ model, highlight }) => {
    const navigate = useNavigate();

    if (!model.hasWorkstreams) {
        return (
            <OverviewCardShell
                title="VDR"
                highlight={highlight ? 'accent' : false}
                footer={<OverviewTextAction onClick={() => navigate('/dataroom')}>Set up workstreams →</OverviewTextAction>}>
                <p className={styles.cardStatus}>Requires workstreams</p>
                <p className={styles.cardDescription}>Set up workstreams before creating the VDR structure.</p>
            </OverviewCardShell>
        );
    }

    if (!model.vdrConfigured) {
        return (
            <OverviewCardShell
                title="VDR"
                highlight={highlight ? 'accent' : false}
                footer={<OverviewTextAction onClick={() => navigate('/dataroom')}>Set up VDR →</OverviewTextAction>}>
                <p className={styles.cardStatus}>Not configured</p>
                <p className={styles.cardDescription}>
                    Create the folder structure for your {model.workstreamCount} configured workstream
                    {model.workstreamCount === 1 ? '' : 's'}.
                </p>
            </OverviewCardShell>
        );
    }

    const vdrView = model.vdrCard;
    const latestUploadLabel =
        vdrView?.latestUploadLabel ||
        (model.vdrLatestUploadAt
            ? `Latest upload ${formatDistanceToNow(new Date(model.vdrLatestUploadAt), { addSuffix: true })}`
            : null);

    const actionLabel = model.documentCount > 0 ? 'Open VDR →' : 'Upload documents →';
    const folderLine = vdrView?.addedRecently
        ? `${model.folderCount} folders · ${vdrView.addedRecently} added recently`
        : `${model.folderCount} folder${model.folderCount === 1 ? '' : 's'}`;

    return (
        <OverviewCardShell
            title="VDR"
            tall={model.documentCount > 0}
            highlight={highlight}
            headerAside={latestUploadLabel ? <span className={styles.cardMutedSmall}>{latestUploadLabel}</span> : null}
            footer={<OverviewTextAction onClick={() => navigate('/dataroom')}>{actionLabel}</OverviewTextAction>}>
            {model.documentCount > 0 ? (
                <>
                    <p className={styles.cardMetric}>{model.documentCount} documents</p>
                    <p className={styles.cardDescription}>{folderLine}</p>
                    {model.vdrPreviewFiles?.length ? (
                        <ul className={styles.filePreviewList}>
                            {model.vdrPreviewFiles.map(name => (
                                <li key={name}>{name}</li>
                            ))}
                        </ul>
                    ) : null}
                </>
            ) : (
                <>
                    <p className={styles.cardMetric}>{model.folderCount} folders</p>
                    <p className={styles.cardDescription}>0 documents — VDR structure ready</p>
                </>
            )}
        </OverviewCardShell>
    );
};

export default VDRCard;
